import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { LANDING_PAGE_LIST } from 'src/constants/queryKeys';

export const networkGetLandingPageInfo = async (landingId) => {
  const res = await axiosInstance.post(`LandPage/Info/${landingId}`);
  return res;
};

export const networkGetLandingPageList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`LandPage/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchLandingPageList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [LANDING_PAGE_LIST, pageIndex, payload],
    queryFn: () => networkGetLandingPageList(payload, pageIndex, pageSize),
  });
}

export const networkCreateLandingPage = async (data) => {
  const res = await axiosInstance.post('LandPage/Insert', data);
  return res;
};

export const networkUpdateLandingPage = async (landingId, data) => {
  const res = await axiosInstance.post(`LandPage/Update/${landingId}`, data);
  return res;
};

export const networkRemoveLandingPage = async (landingId) => {
  const res = await axiosInstance.post(`LandPage/Remove/${landingId}`);
  return res;
};

export const networkGetLandingPageCategoryList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`LandPageCategory/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchLandingPageCategoryList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['landing-page-category-list', pageIndex],
    queryFn: () => networkGetLandingPageCategoryList(pageIndex, pageSize),
  });
}
